import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEOHead = ({
  title,
  description,
  keywords,
  url = "https://tubedigest.ai/",
  image = "https://tubedigest.ai/og-image.png",
  type = "website"
}) => {
  const { t } = useTranslation();

  // 다국어 기본값 설정
  const defaultTitle = title || t('seo.title');
  const defaultDescription = description || t('seo.description');
  const defaultKeywords = keywords || t('seo.keywords');
  return (
    <Helmet>
      <title>{defaultTitle}</title>
      <meta name="description" content={defaultDescription} />
      <meta name="keywords" content={defaultKeywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph */}
      <meta property="og:title" content={defaultTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="TubeDigest" />
      <meta property="og:locale" content="ko_KR" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={defaultTitle} />
      <meta name="twitter:description" content={defaultDescription} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={url} />
    </Helmet>
  );
};

export default SEOHead; 